export const SETUP_COMINFO_COMPANY_INFO = "SETUP_COMINFO_COMPANY_INFO";



// WEBPACK FOOTER //
// ./src/views/Setup/CompanyInfo/flow/actionType.js